import './lib/polyfill';
import './lib/escape-in-app-browser';

export {};
